import { h } from 'preact'
/** @jsx h */
import { useAppState } from '../state/Quiz.context'
import { Next } from './Next'
import { Previous } from './Previous'
import { WIZARD_ANSWER } from '../state/actions/Wizard.actions'
import { WizardResult } from './WizardResult'
import { WizardAnswer } from './WizardAnswer'
import classNames from 'classnames'
import { WizardMeta } from './WizardMeta'
export const Wizard = () => {
  const [{ wizard, quiz, results }, dispatch] = useAppState()
  const question = quiz[wizard.current]
  const previousQuestion = quiz[wizard.previous]
  const nextQuestion = quiz[wizard.next]
  const result =
    !question && results.items[wizard.current] !== undefined
      ? results.items[wizard.current]
      : undefined
  const nextResult =
    question && results.items[wizard.next] !== undefined
      ? results.items[wizard.next]
      : undefined

  return (
    <div
      className={classNames('c-quiz__wrapper', {
        'c-quiz__questioning': question !== undefined,
        'c-quiz__resulted': result !== undefined
      })}
    >
      {previousQuestion === undefined && (
        <WizardMeta title={wizard.title} description={wizard.description} />
      )}
      {result !== undefined && (
        <WizardMeta title={results.title} description={results.description} />
      )}
      {question && (
        <h1 class="c-quiz__question-title u-squeeze--m">{question.title}</h1>
      )}

      <div className="c-quiz__wizard">
        <div className="c-quiz__previous c-quiz__previous--desktop">
          <Previous disabled={previousQuestion === undefined} />
        </div>
        {question && <WizardAnswer />}
        {result && <WizardResult />}
        <div className="c-quiz__next  c-quiz__next--desktop">
          <Next
            disabled={
              result === undefined &&
              nextQuestion === undefined &&
              nextResult === undefined
            }
          />
        </div>
      </div>
      <div className="c-quiz__bottom-bar">
        <div className="c-quiz__previous c-quiz__previous--mobile">
          <Previous disabled={previousQuestion === undefined} />
        </div>
        <div className="c-quiz__next  c-quiz__next--mobile">
          <Next
            disabled={
              result === undefined &&
              nextQuestion === undefined &&
              nextResult === undefined
            }
          />
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/js/quiz/components/Wizard.jsx